import { createSlice } from '@reduxjs/toolkit';
export const ResourceDistributionSlice = createSlice({
  name: 'ResourceDistributionSlice',
  initialState: {
    dataSet: {
      series: [{
        data: []
      }]
    },
    resourceDistributionData: {},
    rowSelected: false
  },
  reducers: {
    pushSelectedRow: (state, action) => {
      state.resourceDistributionData = action.payload;
      let selectedSingleRow = state.resourceDistributionData;
      state.dataSet.series[0].data = [selectedSingleRow['unUsedAccessScore'], selectedSingleRow['usedAccessScore']];
    }
  }
});
export const {
  pushSelectedRow
} = ResourceDistributionSlice.actions;
export default ResourceDistributionSlice.reducer;